import styled from 'styled-components'

import { boxModelTypes, cssTypes } from '../types'
import { boxModel, css } from '../util'

/**
 * @namespace Audio
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const Audio = styled.audio`
  ${boxModel};
  ${css};
`

/**
 * @name defaultProps
 * @memberof Audio
 * @desc Primitive's default properties
 */
Audio.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['32px', '100%'],
}

/**
 * @name propTypes
 * @memberof Audio
 * @desc Primitive's prop type definitions
 */
Audio.propTypes = {
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default Audio
